<template>
  <div id="drag-drop">
    <draggable v-model="data" @end="onEnd">
      <transition-group class="row">
        <div class="col-sm-4 list-complete-item" v-for="item in data" :key="item.uuid">
          <div class="box-detail">{{item.name}}</div>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>
<style scoped>
  .list-complete-item {
    display: flex;
    transition: all .5s;
    margin-bottom: 10px;
  }
  .box-detail {
    flex: 1;
    border-radius: 4px;
    border: 1px solid #ff553a;
    background: #ffae83;
    text-align: center;
    padding: 10px;
    cursor: move;
  }
</style>
<script>
import draggable from 'vuedraggable'
export default {
  name: 'DragDropA',
  components: {
    draggable
  },
  props: {
    value: {
      required: false
    },
    sort_field: {
      required: false
    }
  },
  data: function () {
    return {
      data: []
    }
  },
  methods: {
    onEnd () {
      for (let i in this.data) {
        this.data[i][this.sort_field] = i
      }
      this.$emit('input', this.data)
    }
  },
  created () {
    this.data = this._.cloneDeep(this.value)
    this.data = this._.sortBy(this.data, [this.sort_field])
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Partials/DragDrop.vue